module.exports = __webpack_public_path__ + "img/medicine-bottles-pills.24caef9e.jpg";